import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { List, ListItem, Grid } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import FormField from 'ui/components/form/FormField';
import { update, populateFields } from 'ui/components/form/FormActions';
import styles from './OrderFilterFormStyle';

class OrderDateFilterForm extends Component {
  state = {
    formdata: {
      order_date_start: {
        element: 'date',
        value: null,
        config: {
          name: 'order_date_start',
          type: 'date',
          label: 'From',
        },
        validation: {
          required: false,
        },
        valid: true,
        touched: true,
        validationMessage: '',
        addeditform: true,
      },
      order_date_end: {
        element: 'date',
        value: null,
        config: {
          name: 'order_date_end',
          type: 'date',
          label: 'To',
        },
        validation: {
          required: false,
        },
        valid: true,
        touched: true,
        validationMessage: '',
        addeditform: true,
      },
    },
  }

  componentDidMount() {
    const { filtersdata } = this.props;
    if (filtersdata.length) {
      for (const key in filtersdata) { // eslint-disable-line
        if (typeof filtersdata[key].order_date_start !== 'undefined') {
          const data = {
            order_date_start: filtersdata[key].order_date_start,
          };
          populateFields(this.state.formdata, data);
        }
        if (typeof filtersdata[key].order_date_end !== 'undefined') {
          const data = {
            order_date_end: filtersdata[key].order_date_end,
          };
          populateFields(this.state.formdata, data);
        }
      }
    }
  }

  getFormattedDate = (plus = 0) => {
    const date = new Date();
    if (plus > 0) {
      date.setDate(date.getDate() + plus);
    }
    const day = (`0${date.getDate()}`).slice(-2);
    const month = (`0${date.getMonth() + 1}`).slice(-2);
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;
  }

  addSearchFilter = (filterData, elid) => {
    const { filtersdata, setfilters, setloadtype } = this.props;
    const filterItems = [...filtersdata];
    if (filterItems.length) {
      let notfound = true;
      for (const key in filterItems) { // eslint-disable-line
        if (filterItems[key].id === filterData.id) {
          if (elid === 'order_date_start') {
            filterItems[key].order_date_start = filterData.order_date_start;
          }
          if (elid === 'order_date_end') {
            filterItems[key].order_date_end = filterData.order_date_end;
          }
          notfound = false;
        }
      }
      if (notfound) {
        filterItems.push({ ...filterData });
      }
    } else {
      filterItems.push({ ...filterData });
    }
    setfilters(filterItems);
    setloadtype('filter updated');
  }
  updateFields = (newFormdata) => {
    this.setState({
      ...this.state,
      formdata: newFormdata,
    });
  }
  updateForm = (element) => {
    const { handleClose } = this.props;
    let closenow = false;
    const newFormdata = update(element, this.state.formdata, '');
    if (element.id === 'order_date_start') {
      const filterData = { id: 2, order_date_start: newFormdata.order_date_start.value };
      this.addSearchFilter(filterData, 'order_date_start');
      if (newFormdata.order_date_end.value !== null) {
        closenow = true;
      }
    }
    if (element.id === 'order_date_end') {
      const filterData = { id: 3, order_date_end: newFormdata.order_date_end.value };
      this.addSearchFilter(filterData, 'order_date_end');
      if (newFormdata.order_date_start.value !== null) {
        closenow = true;
      }
    }
    this.setState({
      formdata: newFormdata,
    });
    if (closenow) {
      handleClose();
    }
  }
  render() {
    const { classes } = this.props;
    return (
      <Fragment>
        <List className={classes.ulistcontainer}>
          <ListItem className="datelist">
            <Grid container >
              <Grid className="datestart dategrid" item xs={12}>
                <FormField
                  id="order_date_start"
                  formdata={this.state.formdata.order_date_start}
                  change={element => this.updateForm(element)}
                />
              </Grid>
            </Grid>
            <Grid container >
              <Grid className="dateend dategrid" item xs={12}>
                <FormField
                  id="order_date_end"
                  formdata={this.state.formdata.order_date_end}
                  change={element => this.updateForm(element)}
                />
              </Grid>
            </Grid>
          </ListItem>
        </List>
      </Fragment>
    );
  }
}

OrderDateFilterForm.propTypes = {
  classes: PropTypes.instanceOf(Object).isRequired,
  setloadtype: PropTypes.func.isRequired,
  setfilters: PropTypes.func.isRequired,
  filtersdata: PropTypes.instanceOf(Object).isRequired,
  handleClose: PropTypes.func.isRequired,
};

export default withStyles(styles)(OrderDateFilterForm);
